import useAudioStream from './useAudioStream';

import { IAudioStream } from '@src/types';

const AudioStream = (audioStream: IAudioStream) => {
  const { autoPlay } = audioStream;
  const { isMuted, audioRef } = useAudioStream(audioStream);

  return (
    <audio muted={isMuted} autoPlay={autoPlay} ref={audioRef}>
      Your browser does not support the audio element.
    </audio>
  );
};

export default AudioStream;
